module.exports = __webpack_public_path__ + "static/media/Nunito-Bold.1cd294a7.ttf";